// extracted by mini-css-extract-plugin
module.exports = {"banner":"_373a3719ba--banner--b0N2H","title":"_373a3719ba--title--IF_5O","icon":"_373a3719ba--icon--WlMR0"};